import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';

const ModalNonaktifkanGenerasi = ({ isOpen, onClose, onSuccess }) => {
  const [generasiList, setGenerasiList] = useState([]);
  const [selectedGenerasi, setSelectedGenerasi] = useState('');
  const [keterangan, setKeterangan] = useState('');
  const [previewCount, setPreviewCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingPreview, setLoadingPreview] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchGenerasiList();
    }
  }, [isOpen]);

  useEffect(() => {
    if (selectedGenerasi) {
      fetchPreviewCount();
    } else {
      setPreviewCount(0);
    }
  }, [selectedGenerasi]);

  const fetchGenerasiList = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/anggota/generasi/list`);
      if (!response.ok) throw new Error('Gagal mengambil daftar generasi');
      const data = await response.json();
      setGenerasiList(data);
    } catch (error) {
      console.error('Error fetching generasi:', error);
      Swal.fire('Error', 'Gagal memuat daftar generasi', 'error');
    }
  };

  const fetchPreviewCount = async () => {
    setLoadingPreview(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/anggota?status=aktif`);
      if (!response.ok) throw new Error('Gagal mengambil data preview');
      const data = await response.json();
      
      const count = data.filter(anggota => 
        anggota.tahun_masuk === selectedGenerasi && anggota.status === 'aktif'
      ).length;
      
      setPreviewCount(count);
    } catch (error) {
      console.error('Error preview count:', error);
      setPreviewCount(0);
    } finally {
      setLoadingPreview(false);
    }
  };

  const handleSubmit = async () => {
    if (!selectedGenerasi) {
      Swal.fire('Peringatan', 'Pilih tahun masuk terlebih dahulu', 'warning');
      return;
    }

    if (previewCount === 0) {
      Swal.fire('Info', 'Tidak ada anggota aktif untuk generasi ini', 'info');
      return;
    }

    const result = await Swal.fire({
      title: 'Konfirmasi Nonaktifkan Generasi',
      html: `
        <p>Anda akan menonaktifkan <strong>${previewCount} anggota</strong> dari generasi <strong>${selectedGenerasi}</strong></p>
        <p style="color: #f14668;">Tindakan ini akan mengubah status mereka menjadi nonaktif!</p>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, Nonaktifkan!',
      cancelButtonText: 'Batal'
    });

    if (result.isConfirmed) {
      setLoading(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/anggota/generasi/nonaktifkan`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            tahun_masuk: selectedGenerasi,
            keterangan: keterangan || `Lulus Tahun Ajaran ${parseInt(selectedGenerasi) + 3}`
          })
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Gagal menonaktifkan generasi');
        }

        const result = await response.json();

        Swal.fire({
          icon: 'success',
          title: 'Berhasil!',
          text: `${result.affected} anggota berhasil dinonaktifkan`,
          confirmButtonText: 'OK'
        });

        setSelectedGenerasi('');
        setKeterangan('');
        setPreviewCount(0);
        onClose();
        if (onSuccess) onSuccess();

      } catch (error) {
        Swal.fire('Gagal', error.message, 'error');
      } finally {
        setLoading(false);
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={onClose}></div>
      <div className="modal-card" style={{ width: '500px' }}>
        <header className="modal-card-head">
          <p className="modal-card-title">Nonaktifkan Anggota per Generasi</p>
          <button className="delete" aria-label="close" onClick={onClose}></button>
        </header>
        
        <section className="modal-card-body">
          <div className="field">
            <label className="label">Pilih Tahun Masuk (Generasi)</label>
            <div className="control">
              <div className="select is-fullwidth">
                <select 
                  value={selectedGenerasi} 
                  onChange={(e) => setSelectedGenerasi(e.target.value)}
                >
                  <option value="">-- Pilih Tahun Masuk --</option>
                  {generasiList.map(tahun => (
                    <option key={tahun} value={tahun}>{tahun}</option>
                  ))}
                </select>
              </div>
            </div>
            <p className="help">Hanya siswa yang akan dinonaktifkan. Guru tidak terpengaruh.</p>
          </div>

          <div className="field">
            <label className="label">Keterangan (Opsional)</label>
            <div className="control">
              <textarea 
                className="textarea" 
                value={keterangan}
                onChange={(e) => setKeterangan(e.target.value)}
                placeholder="Misal: Lulus Tahun Ajaran 2025/2026"
                rows="2"
              />
            </div>
          </div>

          {selectedGenerasi && (
            <div className="notification is-info is-light">
              <p className="has-text-weight-bold">Preview:</p>
              {loadingPreview ? (
                <p>Memuat data...</p>
              ) : (
                <div>
                  <p>📊 <strong>{previewCount} siswa</strong> akan dinonaktifkan</p>
                  <p>📅 Generasi: <strong>{selectedGenerasi}</strong></p>
                  <p>🎓 Tahun Lulus: <strong>{parseInt(selectedGenerasi) + 3}</strong></p>
                </div>
              )}
            </div>
          )}

          <div className="field">
            <div className="control">
              <button 
                onClick={handleSubmit}
                className={`button is-danger is-fullwidth ${loading ? 'is-loading' : ''}`}
                disabled={loading || previewCount === 0}
              >
                Nonaktifkan Generasi
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ModalNonaktifkanGenerasi;